import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, type SelectOption } from '@semsis/ui/Select';
import styles from './LanguageSelector.module.css';

// Static option list — module scope so it is not re-allocated on every render.
export const languageOptions: SelectOption[] = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'es', label: 'Español' },
  { value: 'pt', label: 'Português' },
];

export function LanguageSelector() {
  const { i18n } = useTranslation();

  const handleLanguageChange = useCallback((lng: string) => {
    i18n.changeLanguage(lng);
  }, [i18n]);

  // Use i18n.resolvedLanguage here, NOT a truncated i18n.language string — truncation
  // would keep the first two chars of a region-tagged code ('de-DE' -> 'de' is fine by
  // luck, but 'fr-FR' -> 'fr' has no matching option and blanks the trigger).
  // resolvedLanguage is already normalised against supportedLngs + fallbackLng, so a
  // region-tagged or unsupported browser locale still resolves to a value present in
  // languageOptions.
  return (
    <div className={styles['language-selector']}>
      <Select
        options={languageOptions}
        value={i18n.resolvedLanguage ?? 'en'}
        onValueChange={handleLanguageChange}
      />
    </div>
  );
}
